import React from "react";
var imageBasePath =
  window.location.protocol + "//" + window.location.host + "/";

export default function Title({ text }) {
  return (
    <div className="title-wrap">
      <h1 className="common-title">{text}</h1>
      <img
        className="bb"
        src={imageBasePath + "border.png"}
        alt={imageBasePath + "border.png"}
      />
    </div>
  );
}
